export default "__VITE_ASSET__BMJYR3jB__"